import { render, staticRenderFns } from "./GeneratorChooserDlg.vue?vue&type=template&id=5315d7f0&scoped=true"
import script from "./GeneratorChooserDlg.vue?vue&type=script&lang=ts"
export * from "./GeneratorChooserDlg.vue?vue&type=script&lang=ts"
import style0 from "./GeneratorChooserDlg.vue?vue&type=style&index=0&id=5315d7f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5315d7f0",
  null
  
)

export default component.exports